import React from "react";
import { FiVolume2 } from "react-icons/fi";
import { FiVolumeX } from "react-icons/fi";
import useGameStore from "../store/gameStore";

function VolumeAdjust() {
  const mute = useGameStore((s) => s.mute);
  const toggleMute = useGameStore((s) => s.toggleMute);

  return (
    <>
      {mute ? (
        <FiVolumeX
          style={{
            zIndex: "4",
            color: "#C3C3C3",
            cursor: "pointer",
            marginBottom: "7px",
            fontSize: "20px",
          }}
          onClick={toggleMute}
        />
      ) : (
        <FiVolume2
          style={{
            zIndex: "4",
            color: "#C3C3C3",
            cursor: "pointer",
            marginBottom: "7px",
            fontSize: "20px",
          }}
          onClick={toggleMute}
        />
      )}
    </>
  );
}

export default VolumeAdjust;
